const actions = {
    FETCH_SHIFT_EMPLOYEES : 'FETCH_SHIFT_EMPLOYEES',
    RESET_FETCH_SHIFT_EMPLOYEE  : 'RESET_FETCH_SHIFT_EMPLOYEE',

    fetchShiftEmployeesAction: (data) => {
        return {
            type: actions.FETCH_SHIFT_EMPLOYEES,
            data: data
        };
    },
    resetShiftEmployeeFormAction: () => {
        return {
            type: actions.RESET_FETCH_SHIFT_EMPLOYEE,
            data: null
        };
    },
}

export default actions;
